import { useEffect, useState } from 'react';
import axios from 'axios';
import { useCookies } from 'react-cookie'
import { api } from '../../common/api'
import { ACCESS_TOKEN } from '../../common/util' 

export type Program = {
    content: ProgramData[];
    number: number;
    totalElements: number;
}

type ProgramData = {
    programId: number;
    programLevel: string;
    detailLevel: number;
    programArea: string;
    programName: string;
};

function useSearchProgram() {
    const baseUrl = api.base_url;
    const [cookies, setCookie, removeCookie] = useCookies([ACCESS_TOKEN]);
    
    const searchProgram = async (searchValue:string, pageNum:number, sizeNum?:number) => {
        const pageValue = pageNum - 1;
        const sizeValue = sizeNum ?? 8;

        try {
            const response = await axios(`${baseUrl}/program/search?searchValue=${searchValue}&size=${sizeValue}&page=${pageValue}`, {
                method: 'GET',
                headers: {
                  'Content-Type':'application/json',
                  'Authorization': `Bearer ${cookies[ACCESS_TOKEN]}`,
                },
            });
            return response.data.data
        } catch (error) {
            console.error(error);
        }
    };

    return { searchProgram };
}

export default useSearchProgram;
